import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { auth } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("eq_user");
    const token  = localStorage.getItem("eq_access_token");
    if (stored && token) {
      try { setUser(JSON.parse(stored)); }
      catch { clearSession(); }
    }
    setLoading(false);
  }, []);

  const clearSession = useCallback(() => {
    localStorage.removeItem("eq_access_token");
    localStorage.removeItem("eq_refresh_token");
    localStorage.removeItem("eq_user");
    setUser(null);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await auth.login({ email, password });
    localStorage.setItem("eq_access_token",  data.access);
    localStorage.setItem("eq_refresh_token", data.refresh);

    const userData = {
      id:                 data.user_id,
      email:              data.email,
      name:               data.name,
      role:               data.role,
      facilityId:         data.facility_id,
      facilityName:       data.facility_name,
      organisationId:     data.organisation_id,     // NEW — Phase B
      organisationName:   data.organisation_name,   // NEW — Phase B
      mustChangePassword: data.must_change_password,
    };

    localStorage.setItem("eq_user", JSON.stringify(userData));
    setUser(userData);
    return userData;
  }, []);

  const logout = useCallback(() => { clearSession(); }, [clearSession]);

  const clearMustChange = useCallback(() => {
    setUser(prev => {
      if (!prev) return prev;
      const updated = { ...prev, mustChangePassword: false };
      localStorage.setItem("eq_user", JSON.stringify(updated));
      return updated;
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, clearMustChange }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
